import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { shawneeConfig } from "./data";

export default function ShawneePage() {
  return <CityPageTemplate config={shawneeConfig} />;
}